import { render, staticRenderFns } from "./DataDrivenTask.vue?vue&type=template&id=704b214e&"
import script from "./DataDrivenTask.vue?vue&type=script&lang=ts&"
export * from "./DataDrivenTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports